import { Component, effect, input, signal } from '@angular/core';
import { EntityStatus } from '@core';
import { DevicesTableV2Component } from '@devices';
import { DeviceTableCols } from '@devices';

import { WidgetDevices } from '../../../models';

@Component({
  host: {
    class: 'overflow-y-auto relative',
  },
  imports: [
    DevicesTableV2Component,
  ],
  selector: 'avs-devices',
  styleUrl: './devices.component.scss',
  templateUrl: './devices.component.html',
})
export class DevicesComponent {
  config = input.required<WidgetDevices>();

  protected columns = [
    DeviceTableCols.INDEX,
    DeviceTableCols.DEVICE_NAME,
    DeviceTableCols.INCIDENTS,
    DeviceTableCols.BUILDING,
    DeviceTableCols.FLOOR,
    DeviceTableCols.ROOM,
    DeviceTableCols.DEVICE_TYPE,
    DeviceTableCols.MANUFACTURER,
    DeviceTableCols.MODEL,
    DeviceTableCols.SERIAL_NUMBER,
    DeviceTableCols.IP_ADDRESS,
    DeviceTableCols.STATUS,
    DeviceTableCols.ACTIONS,
  ];

  protected filters = signal({});

  constructor() {
    effect(() => {
      this.filters.set({
        location: this.config().locationId,
        space: this.config().roomId ?? this.config().floorId,
        status: [EntityStatus.Active, EntityStatus.Paused, EntityStatus.Deactivated],
      });
    });
  }
}
